<!--
2023-11-02 YTW 印度排灯节
-->
<template>
  <div class="main-content">
    <div class="container" :style="{backgroundImage:'url('+require('../../assets/images/depositActivity/bk.png')+')'}">
      <div class="topBack">
        <img :src="back" alt="" @click="goBack" class="back">
        <div class="title-box">
          <div class="title" :style="$store.state.locale==='IN'?'font-size:7.35vw;':''">
            <span class="title_back">{{ $t('lang.diwali.depTitle') }}</span>
            <span class="title_shadow">{{ $t('lang.diwali.depTitle') }}</span>
            <span class="title_front">{{ $t('lang.diwali.depTitle') }}</span>
          </div>
          <div class="title" :style="$store.state.locale==='IN'?'font-size:7.35vw;':''">
            <span class="title_back">{{ $t('lang.diwali.depTitle1') }}</span>
            <span class="title_shadow">{{ $t('lang.diwali.depTitle1') }}</span>
            <span class="title_front">{{ $t('lang.diwali.depTitle1') }}</span>
          </div>
        </div>
      </div>
      <div class="top-title">
        <div class="title-tip1">
          <span class="title-text">{{ $t('lang.diwali.top1') }}</span>
          <span class="title-amount">{{ $t('lang.account.currencyType') }}77</span>
        </div>
        <div class="title-tip2">
          <span class="title-text">{{ $t('lang.diwali.top2') }}</span>
          <span class="title-amount">{{ $t('lang.account.currencyType') }}2111</span>
        </div>
        <div class="title-tip3">
          <span>{{ $t('lang.diwali.progress') }}</span>
        </div>
        <div class="title-tip4">
          <span>{{ progressText }}</span>
        </div>
      </div>
      <div class="circle-progress">
        <ArcuateProgress :progressEnd="progress" :progressText="progressText"></ArcuateProgress>
      </div>
      <div class="getBtn"
           :style="{backgroundImage:'url('+require('../../assets/images/depositActivity/getBtn.png')+')'}"
           v-if="total&&total.Status === 0" @click="collect(total)">
        {{ $t('lang.diwali.btn0') }}
      </div>
      <div class="getBtn-disable"
           :style="{backgroundImage:'url('+require('../../assets/images/depositActivity/getBtn-disable.png')+')'}"
           v-else-if="total&&total.Status === 1" @click="toastMsg(0)">
        {{ $t('lang.diwali.btn1') }}
      </div>
      <div class="getBtn-disable"
           :style="{backgroundImage:'url('+require('../../assets/images/depositActivity/getBtn-disable.png')+')'}"
           v-else
           @click="toastMsg(0)">
        {{ $t('lang.diwali.btn0') }}
      </div>
      <div class="gradientTitle" style="margin-top: 10vw" v-if="today&&today.Activity">
        <div><img :src="titleImg"></div>
        <div>{{ $t('lang.diwali.todayProgress') }}</div>
      </div>
      <div class="todayProgress" v-if="today&&today.Activity">
        <div class="progressRow">
          <div class="candleDiv"><img :src="candle"></div>
          <div class="progressLineDiv">
            <div class="progress-title">
              <div>{{ $t('lang.diwali.progress') }}</div>
              <div>{{ today.DepositAmount }}/{{ today.TargetAmount }}</div>
            </div>
            <div class="progress-line">
              <progressLine
                :total="today.TargetAmount"
                :current="today.DepositAmount"
                backColor="#ffffff"
              ></progressLine>
            </div>
          </div>
          <div class="getBtnInRow"
               :style="{backgroundImage:'url('+require('../../assets/images/depositActivity/littleBorder.svg')+')'}"
               v-if="today.Status === 0" @click="collect(today)">
            <div :class="'getInner'+css">
              {{ $t('lang.diwali.btn0') }}
            </div>
          </div>
          <div class="getBtnInRow-disable-2"
               :style="{backgroundImage:'url('+require('../../assets/images/depositActivity/disableBorder.svg')+')'}"
               v-else-if="today.Status === 1" @click="toastMsg(0)">
            <div :class="'getInner'+css">
              {{ $t('lang.diwali.btn1') }}
            </div>
          </div>
          <div class="getBtnInRow-disable"
               :style="{backgroundImage:'url('+require('../../assets/images/depositActivity/disableBorder.svg')+')'}"
               v-else-if="today.Status === -1" @click="toastMsg(0)">
            <div :class="'getInner' +css">
              {{ $t('lang.diwali.btn0') }}
            </div>
          </div>
          <div class="getBtnInRow-2" v-else-if="today.Status === -2" @click="toastMsg(1)">
            <div class="getInner">
              <div :class="'innerBack'+css">
                {{ $t('lang.diwali.btn02') }}
              </div>
            </div>
          </div>
          <div class="getBtnInRow-disable-1" v-else-if="today.Status === 9" @click="toastMsg(0)"
               :style="{backgroundImage:'url('+require('../../assets/images/depositActivity/disableBorder.svg')+')'}">
            <div :class="'getInner'+css">
              {{ $t('lang.diwali.btn9') }}
            </div>
          </div>
        </div>
      </div>
      <div class="gradientTitle" :style="today&&today.Activity?'margin-top: 5vw':'margin-top: 8vw'">
        <div><img :src="titleImg" alt=""></div>
        <div>{{ $t('lang.diwali.allProgress') }}</div>
      </div>
      <div id="historyProgress" class="historyProgress">
        <div class="out" v-for="(item,index) in history" :key="index">
          <div class="date">{{ item.ActivityName.substring(5, 10).replace('-', '.') }}</div>
          <div class="progressRow">
            <div class="candleDiv"><img :src="candle"></div>
            <div class="progressLineDiv">
              <div class="progress-title">
                <div>{{ $t('lang.diwali.progress') }}</div>
                <div>{{ item.DepositAmount }}/{{ item.TargetAmount }}</div>
              </div>
              <div class="progress-line">
                <progressLine
                  :total="item.TargetAmount"
                  :current="item.DepositAmount"
                  backColor="#ffffff"
                ></progressLine>
              </div>
            </div>
            <div class="getBtnInRow"
                 :style="{backgroundImage:'url('+require('../../assets/images/depositActivity/littleBorder.svg')+')'}"
                 v-if="item.Status === 0" @click="collect(item)">
              <div :class="'getInner'+css">
                {{ $t('lang.diwali.btn0') }}
              </div>
            </div>
            <div class="getBtnInRow-disable-2"
                 :style="{backgroundImage:'url('+require('../../assets/images/depositActivity/disableBorder.svg')+')'}"
                 v-else-if="item.Status === 1" @click="toastMsg(0)">
              <div :class="'getInner'+css">
                {{ $t('lang.diwali.btn1') }}
              </div>
            </div>
            <div class="getBtnInRow-disable"
                 :style="{backgroundImage:'url('+require('../../assets/images/depositActivity/disableBorder.svg')+')'}"
                 v-else-if="item.Status === -1" @click="toastMsg(0)">
              <div :class="'getInner' +css">
                {{ $t('lang.diwali.btn0') }}
              </div>
            </div>
            <div class="getBtnInRow-2"
                 :style="{backgroundImage:'url('+require('../../assets/images/depositActivity/littleBorder.svg')+')'}"
                 v-else-if="item.Status === -2" @click="toastMsg(1)">
              <div :class="'getInner' +css">
                {{ $t('lang.diwali.btn02') }}
              </div>
            </div>
            <div class="getBtnInRow-disable-1"
                 :style="{backgroundImage:'url('+require('../../assets/images/depositActivity/disableBorder.svg')+')'}"
                 v-else-if="item.Status === 9" @click="toastMsg(0)">
              <div :class="'getInner'+css">
                {{ $t('lang.diwali.btn9') }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="more">
        <img :src="more" @click="letMeSeeMore" v-if="history&&history.length>2&&arrowShow" alt="">
      </div>
      <div class="gradientTitle" style="margin-top: 3vw">
        <div><img :src="ruleImg" alt=""></div>
        <div
          style="background: linear-gradient(89.05deg, #FFF5C9 -10.35%, #FDF380 98.68%);-webkit-background-clip: text;-webkit-text-fill-color: transparent;">
          {{
            $t('lang.diwali.rules')
          }}
        </div>
      </div>
      <div class="rules">
        <p v-for="(rule,inx) in $t('lang.diwali.ruleContent')" :key="inx">
          {{ rule }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import cloud from '@/assets/images/depositActivity/cloud.svg'
import more from '@/assets/images/depositActivity/more.svg'
import back from '@/assets/images/depositActivity/backWhite.svg'
import candle from '@/assets/images/depositActivity/candle.svg'
import titleImg from '@/assets/images/diwali/titleImg.svg'
import ruleImg from '@/assets/images/depositActivity/ruleImg.svg'
import ArcuateProgress from '@/components/ArcuateProgress'
import progressLine from '@/components/ProgressLine/progress'
import request from '@/service'
import {Toast} from 'mint-ui'
import {fetchBalance} from '@/utils'

export default {
  name: 'DepositActivity',
  data () {
    return {
      fetchBalance,
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      cloud,
      back,
      more,
      candle,
      ruleImg,
      titleImg,
      cash: {},
      progress: 0,
      progressText: '',
      today: {},
      total: {},
      history: [],
      css: '-EN',
      arrowShow: true,
      intervalId: null
    }
  },
  components: {
    ArcuateProgress,
    progressLine
  },
  watch: {
    '$store.state.locale': function (n, o) {
      if (n === 'EN') {
        this.css = '-EN'
      } else if (n === 'IN') {
        this.css = '-IN'
      }
    }
  },
  mounted () {
    if (!this.userInfo) {
      // this.$store.commit('setLoginPopShow', true)
      this.$router.push('/Login')
      return
    }
    let locale = this.$store.state.locale
    if (locale === 'EN') {
      this.css = '-EN'
    } else if (locale === 'IN') {
      this.css = '-IN'
    }
    window.addEventListener('scroll', this.historyScroll, true)
    this.fetchAmount()
    this.fetchData()
  },
  updated () {
  },
  destroyed () {
    window.removeEventListener('scroll', this.historyScroll, true)
  },
  methods: {
    historyScroll () {
      let element = document.querySelector('#historyProgress')
      const bottomHeight = (element.scrollHeight - (element.scrollTop + element.clientHeight))
      if (bottomHeight > 5) {
        this.arrowShow = true
      } else {
        this.arrowShow = false
      }
    },
    letMeSeeMore () {
      let element = document.querySelector('#historyProgress')
      const currentHeight = element.scrollTop
      const targetHeight = currentHeight + (element.offsetHeight)
      element.scrollTop = targetHeight
    },
    fetchAmount () {
      const url = '/innovation/dival/setting'
      const data = {}
      request('post', url, data, false).then(res => {
        this.cash = res
      }).catch(err => {
        console.log(err)
      })
    },
    fetchData () {
      const url = '/innovation/dival/getdata'
      const data = {
        UserId: this.userInfo.UserId
      }
      request('post', url, data, false).then(res => {
        if (res && res.length > 0) {
          this.history = []
          res.forEach((act, index) => {
            if (act.Activity) {
              this.today = act
            } else if (index < (res.length - 1)) {
              this.history.push(act)
            } else {
              this.total = act
              this.progress = Math.round(act.DepositAmount / act.TargetAmount * 100)
              if (this.progress > 100) {
                this.progress = 100
              }
              this.progressText = act.DepositAmount + '/' + act.TargetAmount
            }
          })
        }
        // this.today.Activity = false
      }).catch(err => {
        console.log(err)
      })
    },
    collect (item) {
      const url = '/innovation/dival/collect'
      const data = {
        UserId: this.userInfo.UserId,
        ActivityName: item.ActivityName
      }
      request('post', url, data, false).then(res => {
        Toast(this.$t('lang.common.success'))
        this.fetchBalance()
        this.fetchData()
      }).catch(err => {
        Toast(this.$t('lang.common.fail'))
        console.log(err)
      })
    },
    toastMsg (index) {
      Toast(this.$t('lang.diwali.msg' + index))
    },
    goBack () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
.main-content {
  position: relative;
  width: 100vw;
  height: 100vh;
  padding: 56px 0 0 0;
  overflow-x: hidden;
  overflow-y: auto;

  .container {
    position: relative;
    width: 100vw;
    min-height: 511.5vw;
    background-position: top;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
  }

  .starlight {
    position: absolute;
    top: 30vw;
    left: 50%;
    z-index: 0;
    transform: translate(-50%);
    width: 100vw;
    height: 98.97vw;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: bottom;
  }

  .topBack {
    position: relative;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 0 5px 0 16px;
    height: 31.3vw;

    img {
      width: 30px;
    }

    .back {
      margin-top: 12.3vw;
      width: 4vw;
      z-index: 2
    }

    .title-box {
      position: absolute;
      left: 50%;
      transform: translate(-50%);
      top: 18vw;
      width: 90vw;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;

      .title {
        position: relative;
        top: 1.5vw;
        left: 50%;
        transform: translate(-50%);
        width: 85vw;
        height: 8.7vw;
        white-space: nowrap;
        overflow: visible;
        text-align: center;

        .title_front {
          position: absolute;
          top: 0;
          left: 50%;
          transform: translate(-50%);
          z-index: 2;
          font-size: 8.7vw;
          font-weight: 700;
          text-align: center;
          letter-spacing: 0.01em;
          background: linear-gradient(92.43deg, #FF5ED2 -10.78%, #F44830 98.74%, #D80075 208.26%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .title_shadow {
          position: absolute;
          top: 0;
          left: 50%;
          transform: translate(-50%);
          z-index: 1;
          font-size: 8.7vw;
          font-weight: 700;
          text-align: center;
          letter-spacing: 0.01em;
          text-shadow: 1px 1px 0 #000000;
        }

        .title_back {
          position: absolute;
          top: 0;
          left: 50%;
          transform: translate(-50%);
          z-index: 0;
          font-size: 8.7vw;
          font-weight: 700;
          text-align: center;
          letter-spacing: 0.01em;
          text-shadow: -0.5px -0.5px 0 #DCDCDC;
        }

      }

      .title1 {
        margin-top: 0.5vw;
        font-size: 8.7vw;
        font-weight: 700;
        text-align: center;
        letter-spacing: 0.01em;
        background: linear-gradient(91.84deg, #CCFF5E -11.36%, #00FFF0 138.49%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
  }

  .top-title {
    position: relative;
    margin-top: 10vw;
    z-index: 2;

    .title-tip1 {
      width: 100vw;
      margin-left: 7vw;
      text-align: left;
      font-size: 8.7vw;
      font-weight: 700;
      line-height: calc(8.7vw + 10px);
      color: #FFFFFF;
      letter-spacing: 0.04em;
    }

    .title-tip2 {
      width: 100vw;
      text-align: center;
      font-size: 7.8vw;
      margin-left: 5vw;
      font-weight: 700;
      line-height: calc(7.8vw + 3px);
      color: #FFFFFF;
      letter-spacing: 0.04em;
    }

    .title-tip3 {
      margin-top: 8vw;
      width: 100vw;
      text-align: center;
      font-size: 5.73vw;
      line-height: 7.8vw;
      font-weight: 700;
      color: #FFFFFF;
      text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
      -webkit-text-stroke: 5px transparent;
      background: #000000 top left / 100% 100%;
      -webkit-background-clip: text;
    }

    .title-tip4 {
      margin-top: 0.5vw;
      width: 100vw;
      text-align: center;
      font-size: 4vw;
      font-weight: 700;
      line-height: calc(4vw + 4px);
      height: calc(4vw + 4px);
      color: #FFFAF1;
      text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
      -webkit-text-stroke: 5px transparent;
      background: #000000 top left / 100% 100%;
      -webkit-background-clip: text;
    }

    .title-amount {
      color: #FFE600;
      text-shadow: 1.5px 1.5px 0 #000000;
    }

    .title-text {
      text-shadow: 0px 1.5px 1.5px black !important;
    }
  }

  .circle-progress {
    position: relative;
    margin-top: -8vw;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2;
  }

  .getBtn {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 16.8vw auto 0 auto;
    width: 70.76vw;
    height: 14.31vw;
    border-radius: 7px;
    color: #252525;
    font-size: 6.34vw;
    font-weight: 700;
    white-space: nowrap;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 3;
  }

  .getBtn-disable {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 16.8vw auto 0 auto;
    width: 70.76vw;
    height: 14.31vw;
    color: #252525;
    font-size: 6.34vw;
    font-weight: 700;
    white-space: nowrap;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 3;
  }

  .getBtnInRow {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24.95vw;
    height: 9vw;
    border-radius: 7px;
    color: #000000;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    .getInner-EN {
      position: absolute;
      top: 4px;
      right: 4px;
      bottom: 4px;
      left: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      letter-spacing: -0.3px;
      line-height: 9vw;
      text-align: center;
      font-size: 3.5vw;
      font-weight: 700;
      white-space: nowrap;
      border-radius: 3px;
      background: linear-gradient(to right, #FCF07B -10.63%, #F0D657 21.63%, #E4BB2F 56.76%, #E6C138 86.6%, #E9CB46 116.65%);
    }

    .getInner-IN {
      position: absolute;
      top: 4px;
      right: 4px;
      bottom: 4px;
      left: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      letter-spacing: -0.3px;
      line-height: 9vw;
      text-align: center;
      font-size: 2.5vw;
      font-weight: 700;
      white-space: nowrap;
      border-radius: 3px;
      background: linear-gradient(to right, #FCF07B -10.63%, #F0D657 21.63%, #E4BB2F 56.76%, #E6C138 86.6%, #E9CB46 116.65%);
    }
  }

  .getBtnInRow-2 {
    position: relative;
    width: 24.95vw;
    height: 9vw;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;

    .getInner-EN {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      letter-spacing: -0.3px;
      line-height: 9vw;
      text-align: center;
      font-size: 3.15vw;
      font-weight: 700;
      background: linear-gradient(151.39deg, #F0D55E 62.26%, #E1A959 164.83%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      white-space: nowrap;
    }

    .getInner-IN {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      letter-spacing: -0.3px;
      line-height: 9vw;
      text-align: center;
      font-size: 2.2vw;
      font-weight: 700;
      background: linear-gradient(151.39deg, #F0D55E 62.26%, #E1A959 164.83%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      white-space: nowrap;
    }
  }

  .getBtnInRow-disable {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24.95vw;
    height: 9vw;
    border-radius: 7px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    color: rgba(0, 0, 0, 0.69);

    .getInner-EN {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      letter-spacing: -0.3px;
      line-height: 9vw;
      text-align: center;
      font-size: 3.5vw;
      font-weight: 700;
      white-space: nowrap;
    }

    .getInner-IN {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      letter-spacing: -0.3px;
      line-height: 9vw;
      text-align: center;
      font-size: 2.5vw;
      font-weight: 700;
      white-space: nowrap;
    }
  }

  .getBtnInRow-disable-1 {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24.95vw;
    height: 9vw;
    border-radius: 7px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    color: #000000;

    .getInner-EN {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      letter-spacing: -0.3px;
      line-height: 9vw;
      text-align: center;
      font-size: 3.5vw;
      font-weight: 700;
      white-space: nowrap;
    }

    .getInner-IN {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      letter-spacing: -0.3px;
      line-height: 9vw;
      text-align: center;
      font-size: 2.5vw;
      font-weight: 700;
      white-space: nowrap;
    }
  }

  .getBtnInRow-disable-2 {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24.95vw;
    height: 9vw;
    border-radius: 7px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    color: #686868;

    .getInner-EN {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      letter-spacing: -0.3px;
      line-height: 9vw;
      text-align: center;
      font-size: 3.5vw;
      font-weight: 700;
      white-space: nowrap;
    }

    .getInner-IN {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      letter-spacing: -0.3px;
      line-height: 9vw;
      text-align: center;
      font-size: 2.5vw;
      font-weight: 700;
      white-space: nowrap;
    }
  }

  .gradientTitle {
    font-size: 5.52vw;
    line-height: 6vw;
    height: 6vw;
    font-weight: 700;
    text-align: left;
    display: flex;
    align-items: center;
    background: linear-gradient(90.14deg, #EDCF4E -10.63%, #FDF380 21.63%, #E9C843 56.76%, #DEAF1B 86.6%, #FBF88A 116.65%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

    img {
      margin: 0.2vw 2vw 0 5vw;
      height: 5.5vw;
    }
  }

  .rules {
    padding: 2vw 5vw;
    font-size: 5.35vw;
    font-weight: 700;
    text-align: left;
    color: #FFFACE;

    p {
      margin-bottom: 2.5vw;
    }
  }

  .todayProgress {
    margin-top: 3vw;
    width: 100vw;

    .progressRow {
      display: flex;
      margin: 0 auto;
      width: 95vw;
      padding: 1vw 2.5vw;
      justify-content: space-between;
      align-items: center;
      background: rgba(75, 13, 13, 0.48);
      border-radius: 7px;

      .progressLineDiv {
        width: 45.4vw;
        height: 13vw;
        display: flex;
        justify-content: space-between;
        flex-direction: column;

        .progress-title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          font-size: 3.89vw;
          line-height: 3.89vw;
          font-weight: 700;
          color: #FFFFFF;
          margin: auto;
        }

        .progress-line {
          width: 100%;
          margin: auto;
        }
      }

      .candleDiv {
        height: 16.67vw;
        width: 16.67vw;
        overflow: hidden;

        img {
          height: 16.67vw
        }
      }
    }
  }

  .historyProgress {
    margin-top: 0;
    width: 100vw;
    height: 124vw;
    overflow-x: hidden;
    overflow-y: auto;

    .out {
      margin-top: 4.5vw;
      width: 100vw;
      height: max-content;
    }

    .date {
      margin-left: 5vw;
      margin-bottom: 1.5vw;
      font-size: 4.5vw;
      font-weight: 700;
      line-height: calc(3px + 4.5vw);
      text-align: left;
      background: linear-gradient(0deg, #FFFBE5, #FFFBE5),
      linear-gradient(0deg, #FFFFFF, #FFFFFF);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    .progressRow {
      display: flex;
      width: 95vw;
      padding: 1vw 2.5vw;
      margin: 0 auto;
      justify-content: space-between;
      align-items: center;
      background: rgba(75, 13, 13, 0.48);
      border-radius: 7px;

      .progressLineDiv {
        width: 45.4vw;
        height: 13vw;
        display: flex;
        justify-content: space-between;
        flex-direction: column;

        .progress-title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          font-size: 3.89vw;
          line-height: 3.89vw;
          font-weight: 700;
          color: #FFFFFF;
          margin: auto;
        }

        .progress-line {
          width: 100%;
          margin: auto;
        }
      }

      .candleDiv {
        height: 16.67vw;
        width: 16.67vw;
        overflow: hidden;

        img {
          height: 16.67vw
        }
      }
    }
  }

  .more {
    margin-top: 2vw;
    display: flex;
    justify-content: center;
    height: max-content;
    min-height: 5.55vw;

    img {
      width: 7.36vw;
    }
  }
}

.main-content::-webkit-scrollbar {
  display: none
}

</style>



// WEBPACK FOOTER //
// src/pages/DepositActivity/index.vue